export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/83e791c702f67cc0242109b04d241be7.svg";